<template>
  <b-row
    class="margin-0 margin-bottom-16 background-surface border--solid border--complementary-50 border-radius-8 padding-16"
  >
    <b-col
      cols="12"
      class="padding-0 margin-bottom-16 font-size-16 color-competency-400"
    >
      {{ $lang.practiceOverview }} ({{ $lang.optional }})
    </b-col>
    <b-col cols="12" lg="4" class="padding-0 margin-bottom-16">
      <EnumDropdown
        :title="$lang.candidateOverallScore"
        :label="$lang.candidateOverallScore"
        :placeholder="$lang.candidateOverallScore"
        :value="form.candidateOverallScore"
        name="candidateOverallScore"
        id="candidateOverallScore"
        categoryName="competency_score"
        :vuelidateObj="$v.form.candidateOverallScore"
        :disabled="!hasItemPermission(['OVERVIEW_EXERCISE'])"
        rowClass=""
        @input="handleUpdate"
        @focus="resetValidation"
        @blur="checkValidation"
      />
    </b-col>
    <b-col cols="12" lg="4" class="padding-0 desktop-padding-x-16">
      <Input
        :title="$lang.strengthAndDevelopment"
        :label="$lang.strengthAndDevelopment"
        :placeholder="$lang.strengthAndDevelopment"
        :value="form.strengthAndDevelopment"
        name="strengthAndDevelopment"
        id="strengthAndDevelopment"
        type="text"
        :vuelidateObj="$v.form.strengthAndDevelopment"
        :disabled="!hasItemPermission(['OVERVIEW_EXERCISE'])"
        rowClass=""
        @input="handleUpdate"
        @focus="resetValidation"
        @blur="checkValidation"
      />
    </b-col>
    <b-col cols="12" lg="4" class="padding-0">
      <Input
        :title="$lang.conclusion"
        :label="$lang.conclusion"
        :placeholder="$lang.conclusion"
        :value="form.exerciseSummary"
        name="exerciseSummary"
        id="exerciseSummary"
        type="text"
        :vuelidateObj="$v.form.exerciseSummary"
        :disabled="!hasItemPermission(['OVERVIEW_EXERCISE'])"
        rowClass=""
        @input="handleUpdate"
        @focus="resetValidation"
        @blur="checkValidation"
      />
    </b-col>
  </b-row>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { EnumDropdown, Input } from "@/components/re-design/forms";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
export default {
  mixins: [inputMixin],
  inject: ["hasItemPermission"],
  components: { EnumDropdown, Input },
  props: {
    exerciseData: {
      type: Object,
      default: null,
    },
  },
  validations() {
    return {
      form: {
        candidateOverallScore: {},
        strengthAndDevelopment: {},
        exerciseSummary: {},
      },
    };
  },
  data() {
    return {
      form: {
        candidateOverallScore: null,
        strengthAndDevelopment: null,
        exerciseSummary: null,
      },
    };
  },
  methods: {
    pathOr,
    handleUpdate(key, value) {
      this.input(key, value);

      // update parent date
      this.$emit("handleUpdate", key, value);
    },
  },
};
</script>
